<template>
  <div class="container">
    <div class="cards" :style="cssProps">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VCardsContainer',
  props: {
    gap: {
      type: String,
      required: false,
      default: '16px',
    },
  },
  computed: {
    cssProps() {
      return {
        '--gap': this.gap,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 98%;
  max-width: 11280px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cards {
  width: 100%;
  margin: 20px 0;
  padding: 20px 0;
  display: grid;
  grid-gap: 14px;
  justify-items: center;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
}

// @media (max-width: 900px) {

// }
</style>
